import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrganizationStudies } from 'src/api/organizations-queries';

export function StudiesTable() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { organizationId } = useParams();

  // const { data, isLoading } = useGetOrganization(organizationId);
  const { data, isLoading } = useGetOrganizationStudies(organizationId);

  const studies = useMemo(() => data?.studies ?? [], [data?.studies]);

  const headers = [
    { label: 'Name', key: 'studyName' },
    { label: 'Display name', key: 'studyDisplayName' },
    { label: 'Created', key: 'createdDate' },
  ];

  const transformedData = useMemo(
    () =>
      studies
        .filter(
          (study) =>
            study.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            study.displayName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((study) => ({
          id: study.studyId,
          studyName: study.name,
          studyDisplayName: study.displayName,
          createdDate: new Date(study.createdAt).toISOString().split('T')[0],
        })) ?? [],
    [studies, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
